// extracted by mini-css-extract-plugin
module.exports = {"employerContent":"_2mF9LoyU","candidateHeader":"_2Wjny43R","stack":"_2LT_yItu","candidateHeaderText":"_2OiT91sR","logoWrapper":"UI_CGs-2","statusContent":"_1yHW3-qW","dateContent":"_1Im447g_","emptyContainerContent":"_3LM0YUHV","emptyContainerString":"_1BUSV_N0","blockTitle":"_3vxYOr00","companyHeader":"_2LWJ7hgr","otherHeader":"_15qEY8mO","actionsContent":"_3ZoRkfQf","candActionHeader":"_2CcUL5X4"};
    if(module.hot) {
      // 1754515030119
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  